import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { createCupom, updateCupom } from "../../services/api";

const CORES = ["vermelho", "laranja", "amarelo"];

export default function CupomModal({ show, onHide, onSaved, cupom }) {
  const [codigo, setCodigo] = useState("");
  const [link, setLink] = useState("");
  const [cores, setCores] = useState(CORES);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!show) return;
    setCodigo(cupom?.codigo || "");
    setLink(cupom?.link || "");
    setCores(Array.isArray(cupom?.cores) && cupom.cores.length ? cupom.cores : CORES);
    setError("");
  }, [show, cupom]);

  const reset = () => {
    setCodigo("");
    setLink("");
    setCores(CORES);
    setError("");
  };

  const close = () => {
    reset();
    onHide();
  };

  const toggleCor = (cor) => {
    setCores((prev) =>
      prev.includes(cor) ? prev.filter((c) => c !== cor) : [...prev, cor]
    );
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!codigo.trim()) {
      setError("Preencha o código do cupom.");
      return;
    }
    setBusy(true);
    setError("");
    try {
      const payload = {
        codigo: codigo.trim().toUpperCase(),
        link: link.trim(),
        cores,
      };
      if (cupom) {
        await updateCupom(cupom.id, payload);
      } else {
        await createCupom(payload);
      }
      reset();
      onSaved();
    } catch (err) {
      setError("Falha ao salvar o cupom.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton>
        <Modal.Title>{cupom ? "Editar Cupom" : "Novo Cupom"}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={submit}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Código (ex: MELI10OFF)</Form.Label>
            <Form.Control
              value={codigo}
              onChange={(e) => setCodigo(e.target.value.toUpperCase())}
              placeholder="MELI10OFF"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Link de destino (opcional)</Form.Label>
            <Form.Control
              value={link}
              onChange={(e) => setLink(e.target.value)}
              placeholder="https://..."
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Cores pré-selecionadas</Form.Label>
            <div className="d-flex flex-wrap" style={{ gap: 12 }}>
              {CORES.map((cor) => (
                <Form.Check
                  key={cor}
                  type="checkbox"
                  label={cor}
                  checked={cores.includes(cor)}
                  onChange={() => toggleCor(cor)}
                />
              ))}
            </div>
          </Form.Group>

          {error && <div className="text-danger mt-3">{error}</div>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={close}>
            Cancelar
          </Button>
          <Button type="submit" variant="primary" disabled={busy}>
            {busy ? "Salvando..." : cupom ? "Salvar" : "Adicionar Cupom"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
